// client/src/pages/secure/PortalAssistantPage.js — Ask the Assistant (Today menu).
// The in-portal assistant for staff, office managers, the managing broker and agents
// (components/secure/PortalAssistantPanel; server routes/chatAdmin.js /my/assistant).
import React from 'react';
import { useApiClient } from '../../hooks/useApiClient';
import PortalAssistantPanel from '../../components/secure/PortalAssistantPanel';

const PortalAssistantPage = () => {
    const api = useApiClient();
    return (
        <div className="space-y-4">
            <div>
                <h1 className="text-2xl font-bold text-slate-800">Ask the Assistant</h1>
                <p className="text-sm text-slate-600">Questions about the portal and the office's own records, answered only from what you may already see.
                    The assistant never changes anything by itself: anything it suggests waits for your Confirm.</p>
            </div>
            <PortalAssistantPanel api={api} />
        </div>
    );
};

export default PortalAssistantPage;
